import React, { useEffect, useRef } from "react";
import AvatarImg from "./AvatarImg";
import useBodyScrollLock from "../hooks/useBodyScrollLock";

export default function AvatarPreviewModal({
  open,
  onClose,
  avatar,
  renk = "#6366f1",
  initials = "?",
  title,
  closeLabel = "Close",
}) {
  const closeButtonRef = useRef(null);
  useBodyScrollLock(open);

  useEffect(() => {
    if (!open) return undefined;

    const previouslyFocused = document.activeElement;
    const focusTimer = window.setTimeout(() => closeButtonRef.current?.focus(), 0);
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        onClose();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => {
      window.clearTimeout(focusTimer);
      document.removeEventListener("keydown", onKeyDown);
      previouslyFocused?.focus?.();
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="avatarPreviewOverlay"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={(event) => {
        event.stopPropagation();
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="avatarPreviewCard" onClick={(event) => event.stopPropagation()}>
        <div className="avatarPreviewHandle" aria-hidden="true" />
        <div className="avatarPreviewHeader">
          <strong>{title}</strong>
          <button
            ref={closeButtonRef}
            type="button"
            className="avatarPreviewClose"
            onClick={onClose}
            aria-label={closeLabel}
          >
            ×
          </button>
        </div>
        <div className="avatarPreviewStage" style={{ "--avatar-preview-color": renk }}>
          <div className="avatarPreviewGlow" aria-hidden="true" />
          <AvatarImg
            avatar={avatar || null}
            renk={renk}
            initials={initials || "?"}
            size={260}
            glow={true}
            radius="50%"
            className="avatarPreviewImage"
          />
        </div>
      </div>
    </div>
  );
}
